import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Box, Container, Button, Typography, alpha } from "@mui/material";
import MobileMenu from "../MobileMenu/MobileMenu";
import Logo1 from "../../images/logo1.png";
import Logo2 from "../../images/logo2.png";
import HeaderTopbar from "../HeaderTopbar";

const serviceNavigation = {
  category1: {
    title: "Business Setup & Compliance",
    link: "/service-group/business-setup-compliance",
    sTitles: [
      {
        title: "Set Up Your Business in India",
        link: "/service-category/setUpYourBusinessInIndia",
        subTopics: [
          {
            title: "India Entry & Entity Structuring",
            link: "/services/indiaEntryAndEntityStructuring",
          },
          {
            title: "FEMA & Cross-Border Advisory",
            link: "/services/femaAndCrossBorderAdvisory",
          },
          {
            title: "Business Registrations, Approvals & Licenses",
            link: "/services/businessRegistrationsApprovalsAndLicenses",
          },
        ],
      },
      {
        title: "Audit & Assurance",
        link: "/service-category/auditAndAssurance",
        subTopics: [
          {
            title: "Statutory, Tax & Internal Audits",
            link: "/services/statutoryTaxAndInternalAudits",
          },
          {
            title: "Management & Operational Audits",
            link: "/services/managementAndOperationalAudits",
          },
          {
            title: "IFC Design & Risk Review",
            link: "/services/ifcDesignAndRiskReview",
          },
          {
            title: "Compliance & Process Assessments",
            link: "/services/complianceAndProcessAssessments",
          },
        ],
      },
      {
        title: "Taxation & Regulatory",
        link: "/service-category/taxationAndRegulatory",
        subTopics: [
          {
            title: "Direct & Indirect Tax Advisory",
            link: "/services/directAndIndirectTaxAdvisory",
          },
          {
            title: "GST Compliance & Litigation Support",
            link: "/services/gstComplianceAndLitigationSupport",
          },
          {
            title: "International Taxation & Transfer Pricing",
            link: "/services/internationalTaxationAndTransferPricing",
          },
          {
            title: "Tax Structuring & Optimization",
            link: "/services/taxStructuringAndOptimization",
          },
        ],
      },
      {
        title: "Accounting & Business Support",
        link: "/service-category/accountingAndBusinessSupportYourFinanceBackOffice",
        subTopics: [
          {
            title: "Outsourced Bookkeeping",
            link: "/services/outsourcedBookkeeping",
          },
          {
            title: "MIS & Management Reporting",
            link: "/services/misAndManagementReporting",
          },
          {
            title: "Financial Process Automation",
            link: "/services/financialProcessAutomation",
          },
          {
            title: "Managed Payroll & People Compliance",
            link: "/services/managedPayrollAndPeopleCompliance",
          },
          {
            title: "IFRS / Ind-AS Accounting Support",
            link: "/services/ifrsIndAsAccountingSupport",
          },
        ],
      },
      {
        title: "Corporate Secretarial & Governance",
        link: "/service-category/corporateSecretarialAndGovernance",
        subTopics: [
          {
            title: "Corporate Law & Secretarial Advisory",
            link: "/services/corporateLawAndSecretarialAdvisory",
          },
          {
            title: "ROC Filings & Statutory Registers",
            link: "/services/rOCFilingsAndStatutoryRegisters",
          },
          {
            title: "Board & Shareholder Governance Support",
            link: "/services/boardAndShareholderGovernanceSupport",
          },
          {
            title: "FEMA/RBI Compliance for Foreign-Owned Entities",
            link: "/services/femaRbiComplianceForForeignOwnedEntities",
          },
        ],
      },
    ],
  },
  category2: {
    title: "Advisory & Deals",
    link: "/service-group/advisory-deals",
    sTitles: [
      {
        title: "IPO Advisory & Capital Markets Readiness",
        link: "/service-category/ipoAdvisoryAndCapitalMarketsReadiness",
        subTopics: [
          {
            title: "IPO Readiness Assessment",
            link: "/services/iPOReadinessAssessment",
          },
          {
            title: "Financial Statement Restatement & Audit Support",
            link: "/services/financialStatementRestatementAndAuditSupport",
          },
          {
            title: "Internal Controls & Corporate Governance Setup",
            link: "/services/internalControlsAndCorporateGovernanceSetup",
          },
          {
            title: "Coordination with Merchant Bankers & Legal Advisors",
            link: "/services/coordinationWithMerchantBankersAndLegalAdvisors",
          },
          {
            title: "Independent Chartered Accountant Certification Services",
            link: "/services/independentCharteredAccountantCertificationServices",
          },
        ],
      },
      {
        title: "Transaction Advisory, Due Diligence & Valuations",
        link: "/service-category/transactionAdvisoryDueDiligenceAndValuations",
        subTopics: [
          {
            title: "M&A Support & Due Diligence",
            link: "/services/mAndASupportAndDueDiligence",
          },
          {
            title: "Business Valuation & Financial Modeling",
            link: "/services/businessValuationAndFinancialModeling",
          },
          {
            title: "Fundraising & Deal Structuring",
            link: "/services/fundraisingAndDealStructuring",
          },
          {
            title: "Post-Merger Integration Assistance",
            link: "/services/postMergerIntegrationAssistance",
          },
        ],
      },
      {
        title: "Management Consulting & Business Transformation",
        link: "/service-category/managementConsultingAndBusinessTransformation",
        subTopics: [
          {
            title: "Business Strategy & Transformation",
            link: "/services/businessStrategyAndTransformation",
          },
          {
            title: "Performance Improvement & Cost Optimization",
            link: "/services/performanceImprovementAndCostOptimization",
          },
          {
            title: "Risk Management & Internal Controls",
            link: "/services/riskManagementAndInternalControls",
          },
          {
            title: "Digital Transformation Advisory",
            link: "/services/digitalTransformationAdvisory",
          },
        ],
      },
      {
        title: "ESG & Sustainability Consulting",
        link: "/service-category/esgAndSustainabilityConsulting",
        subTopics: [
          {
            title: "ESG Reporting & Disclosures",
            link: "/services/eSGReportingAndDisclosures",
          },
          {
            title: "Sustainability Strategy & Carbon Footprint Analysis",
            link: "/services/sustainabilityStrategyAndCarbonFootprintAnalysis",
          },
          {
            title: "CSR Compliance Advisory",
            link: "/services/cSRComplianceAdvisory",
          },
        ],
      },
      {
        title: "Virtual CFO Services",
        link: "/service-category/virtualCfoServices",
        subTopics: [
          {
            title: "Strategic Financial Leadership",
            link: "/services/strategicFinancialLeadershipWithoutAFullTimeCfo",
          },
          {
            title: "Board-level Financial Advisory",
            link: "/services/boardLevelFinancialAdvisory",
          },
          {
            title: "Business Performance Review",
            link: "/services/businessPerformanceReview",
          },
          {
            title: "Capital Allocation & Cash-flow Planning",
            link: "/services/capitalAllocationAndCashFlowPlanning",
          },
          {
            title: "Investor & Lender Reporting",
            link: "/services/investorAndLenderReporting",
          },
        ],
      },
    ],
  },
};

const Header = (props) => {
  const [isSticky, setIsSticky] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [kbMenuOpen, setKbMenuOpen] = useState(false);
  const [crMenuOpen, setCrMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const ClickHandler = () => {
    window.scrollTo(0, 0);
    setMenuOpen(false);
    setKbMenuOpen(false);
    setCrMenuOpen(false);
  };

  return (
    <header id="header" className="site-header">
      <HeaderTopbar container={"xl"} />

      <Box
        sx={{
          width: "100%",
          bgcolor: isSticky
            ? "rgba(255,255,255,0.98)"
            : "rgba(255,255,255,0.05)",
          backdropFilter: isSticky ? "blur(15px)" : "none",
          boxShadow: isSticky ? "0 15px 40px rgba(0,0,0,0.08)" : "none",
          position: isSticky ? "fixed" : "relative",
          top: 0,
          left: 0,
          zIndex: 1000,
          transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
          borderBottom: isSticky
            ? "1px solid rgba(0,0,0,0.05)"
            : "1px solid rgba(255,255,255,0.1)",
        }}
      >
        <Container maxWidth="xl">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: isSticky ? 1.5 : 2.5,
            }}
          >
            {/* Logo Section */}
            <Link
              onClick={ClickHandler}
              to="/"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                textDecoration: "none",
                transition: "0.4s ease",
              }}
            >
              <img
                src={isSticky ? Logo2 : Logo1}
                alt="Logo"
                style={{
                  height: isSticky ? "36px" : "48px",
                  width: "auto",
                  transition: "0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  objectFit: "contain",
                }}
              />
              <Typography
                component="span"
                sx={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: isSticky
                    ? "var(--primary-color)"
                    : "rgba(255,255,255,0.9)",
                  marginTop: "3px",
                  letterSpacing: "1.5px",
                  textTransform: "uppercase",
                  opacity: 0.9,
                  transition: "color 0.4s ease",
                }}
              >
                Together Makes Progress
              </Typography>
            </Link>
            {/* Desktop Navigation */}
            <Box sx={{ display: { xs: "none", lg: "block" }, flex: 1, px: 2 }}>
              <ul className="premium-nav">
                <li className="nav-item">
                  <Link
                    onClick={ClickHandler}
                    to="/"
                    className={isSticky ? "dark" : ""}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className={`nav-item has-mega ${menuOpen ? "active" : ""}`}
                  onMouseEnter={() => setMenuOpen(true)}
                  onMouseLeave={() => setMenuOpen(false)}
                >
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    to="#"
                    className={isSticky ? "dark" : ""}
                  >
                    Services
                  </Link>
                  <div className={`mega-menu ${menuOpen ? "show" : ""}`}>
                    <Container maxWidth="lg" sx={{ p: 0 }}>
                      <Box sx={{ display: "flex", width: "100%" }}>
                        {/* Column 1: BUSINESS SETUP */}
                        <Box
                          sx={{
                            width: "50%",
                            p: 4,
                            borderRight: "1px solid rgba(0,0,0,0.06)",
                          }}
                        >
                          <Link
                            to={serviceNavigation.category1.link}
                            onClick={ClickHandler}
                            className="mega-category-title"
                          >
                            {serviceNavigation.category1.title}
                          </Link>
                          <Box
                            component="ul"
                            sx={{ listStyle: "none", p: 0, m: 0 }}
                          >
                            {serviceNavigation.category1.sTitles.map(
                              (item, idx) => (
                                <Box
                                  key={idx}
                                  component="li"
                                  className="mega-item-wrapper"
                                >
                                  <Link
                                    to={item.link}
                                    onClick={ClickHandler}
                                    className="mega-stitle-link"
                                  >
                                    {item.title}
                                  </Link>
                                  {/* Nested Flyout Dropdown */}
                                  <Box className="flyout-box">
                                    <Box
                                      component="ul"
                                      sx={{ listStyle: "none", p: 0, m: 0 }}
                                    >
                                      {item.subTopics.map((sub, sidx) => (
                                        <li
                                          key={sidx}
                                          style={{ marginBottom: "8px" }}
                                        >
                                          <Link
                                            to={sub.link}
                                            onClick={ClickHandler}
                                            className="mega-subtopic-link"
                                          >
                                            {sub.title}
                                          </Link>
                                        </li>
                                      ))}
                                    </Box>
                                  </Box>
                                </Box>
                              ),
                            )}
                          </Box>
                        </Box>
                        {/* Column 2: ADVISORY & DEALS */}
                        <Box sx={{ width: "50%", p: 4 }}>
                          <Link
                            to={serviceNavigation.category2.link}
                            onClick={ClickHandler}
                            className="mega-category-title"
                          >
                            {serviceNavigation.category2.title}
                          </Link>
                          <Box
                            component="ul"
                            sx={{ listStyle: "none", p: 0, m: 0 }}
                          >
                            {serviceNavigation.category2.sTitles.map(
                              (item, idx) => (
                                <Box
                                  key={idx}
                                  component="li"
                                  className="mega-item-wrapper"
                                >
                                  <Link
                                    to={item.link}
                                    onClick={ClickHandler}
                                    className="mega-stitle-link"
                                  >
                                    {item.title}
                                  </Link>
                                  {/* Nested Flyout Dropdown (Positioned left for right column) */}
                                  <Box className="flyout-box left">
                                    <Box
                                      component="ul"
                                      sx={{ listStyle: "none", p: 0, m: 0 }}
                                    >
                                      {item.subTopics.map((sub, sidx) => (
                                        <li
                                          key={sidx}
                                          style={{ marginBottom: "8px" }}
                                        >
                                          <Link
                                            to={sub.link}
                                            onClick={ClickHandler}
                                            className="mega-subtopic-link"
                                          >
                                            {sub.title}
                                          </Link>
                                        </li>
                                      ))}
                                    </Box>
                                  </Box>
                                </Box>
                              ),
                            )}
                          </Box>
                        </Box>
                      </Box>
                    </Container>
                  </div>
                </li>

                <li className="nav-item">
                  <Link
                    onClick={ClickHandler}
                    to="/about"
                    className={isSticky ? "dark" : ""}
                  >
                    About
                  </Link>
                </li>

                <li
                  className={`nav-item has-dropdown ${
                    kbMenuOpen ? "active" : ""
                  }`}
                  onMouseEnter={() => setKbMenuOpen(true)}
                  onMouseLeave={() => setKbMenuOpen(false)}
                >
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    to="#"
                    className={isSticky ? "dark" : ""}
                  >
                    Knowledge Bank
                  </Link>
                  <ul
                    className={`premium-dropdown ${kbMenuOpen ? "show" : ""}`}
                  >
                    <li>
                      <Link to="/calculator" onClick={ClickHandler}>
                        Financial Calculators
                      </Link>
                    </li>
                    <li>
                      <Link to="/links" onClick={ClickHandler}>
                        Resources & Portals
                      </Link>
                    </li>
                    <li>
                      <Link to="/acts" onClick={ClickHandler}>
                        Bare Acts & Statutes
                      </Link>
                    </li>
                  </ul>
                </li>

                <li
                  className={`nav-item has-dropdown ${
                    crMenuOpen ? "active" : ""
                  }`}
                  onMouseEnter={() => setCrMenuOpen(true)}
                  onMouseLeave={() => setCrMenuOpen(false)}
                >
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    to="#"
                    className={isSticky ? "dark" : ""}
                  >
                    Careers
                  </Link>
                  <ul
                    className={`premium-dropdown ${crMenuOpen ? "show" : ""}`}
                  >
                    <li>
                      <Link to="/whyJoinUs" onClick={ClickHandler}>
                        Why Join Us
                      </Link>
                    </li>
                    <li>
                      <Link to="/currentOpenings" onClick={ClickHandler}>
                        Opportunities
                      </Link>
                    </li>
                    <li>
                      <Link to="/testimonials" onClick={ClickHandler}>
                        Testimonials
                      </Link>
                    </li>
                    <li>
                      <Link to="/applyNow" onClick={ClickHandler}>
                        Join The Team
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="nav-item">
                  <Link
                    onClick={ClickHandler}
                    to="/contact"
                    className={isSticky ? "dark" : ""}
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </Box>

            {/* Right Side Tools */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
              {/* <Button
                component={Link}
                to="/contact"
                variant="contained"
                sx={{
                  display: { xs: "none", xl: "flex" },
                  bgcolor: isSticky
                    ? "var(--primary-color)"
                    : alpha("#fff", 0.9),
                  color: isSticky ? "#fff" : "var(--primary-color)",
                  borderRadius: "12px",
                  px: 4,
                  py: 1.2,
                  fontWeight: 800,
                  textTransform: "none",
                  fontSize: "0.9rem",
                  boxShadow: isSticky
                    ? "0 10px 25px rgba(26, 66, 161, 0.2)"
                    : "none",
                  transition: "0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  "&:hover": {
                    bgcolor: isSticky ? "var(--turquoise-color)" : "#fff",
                    transform: "translateY(-2px)",
                    boxShadow: "0 15px 30px rgba(0,0,0,0.15)",
                  },
                }}
              >
                Free Consultation
              </Button> */}
              <Box sx={{ display: { lg: "none" } }}>
                <MobileMenu isSticky={isSticky} />
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>

      <style
        dangerouslySetInnerHTML={{
          __html: `
        .premium-nav {
          display: flex;
          list-style: none;
          padding: 0;
          margin: 0;
          justify-content: center;
          gap: 10px;
        }
        .premium-nav .nav-item {
          position: relative;
          padding: 10px 0;
        }
        .premium-nav .nav-item > a {
          color: #fff;
          font-weight: 700;
          font-size: 0.95rem;
          padding: 12px 18px;
          text-decoration: none;
          transition: 0.3s;
          border-radius: 12px;
          display: flex;
          align-items: center;
          letter-spacing: 0.2px;
          position: relative;
        }
        .premium-nav .nav-item > a.dark {
          color: #2d3748;
        }
        .premium-nav .nav-item:hover > a {
          color: #fff !important;
        }
        .premium-nav .nav-item:hover > a.dark {
          color: var(--primary-color) !important;
        }
        
        /* Dropdown Styling */
        .premium-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          background: #fff;
          min-width: 240px;
          box-shadow: 0 25px 50px rgba(0,0,0,0.15);
          border-radius: 16px;
          padding: 12px;
          list-style: none;
          opacity: 0;
          visibility: hidden;
          transform: translateY(20px);
          transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          border: 1px solid rgba(0,0,0,0.05);
          z-index: 2002;
        }
        .premium-dropdown.show {
          opacity: 1;
          visibility: visible;
          transform: translateY(5px);
        }
        .premium-dropdown li a {
          display: block;
          padding: 12px 18px;
          color: #4a5568;
          text-decoration: none;
          font-weight: 600;
          font-size: 0.9rem;
          border-radius: 10px;
          transition: 0.2s;
        }
        .premium-dropdown li a:hover {
          background: #f7fafc;
          color: var(--primary-color);
        }
        
        /* Mega Menu Styling */
        .mega-menu {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%) translateY(30px);
          width: 800px;
          background: #fff;
          box-shadow: 0 40px 80px rgba(0,0,0,0.18);
          opacity: 0;
          visibility: hidden;
          transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          border-radius: 20px;
          z-index: 2001;
          border: 1px solid rgba(0,0,0,0.05);
          overflow: visible;
        }
        .nav-item.has-mega:hover .mega-menu,
        .mega-menu.show {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0);
        }

        .mega-category-title {
           display: block;
           font-size: 1.1rem;
           font-weight: 900;
           color: var(--primary-color);
           margin-bottom: 25px;
           text-decoration: none;
           border-bottom: 2px solid var(--primary-color);
           padding-bottom: 10px;
           transition: 0.3s;
        }
        .mega-category-title:hover {
           opacity: 0.7;
        }

        .mega-item-wrapper {
           position: relative;
           margin-bottom: 5px;
        }

        .mega-stitle-link {
           display: block;
           padding: 10px 15px;
           color: #333;
           font-weight: 700;
           font-size: 0.95rem;
           text-decoration: none;
           border-radius: 10px;
           transition: 0.3s;
        }
        .mega-stitle-link:hover {
           background: rgba(26, 66, 161, 0.05);
           color: var(--primary-color);
        }

        /* Flyout Logic */
        .flyout-box {
           position: absolute;
           left: 100%;
           top: -10px;
           width: 300px;
           background: #fff;
           box-shadow: 0 15px 40px rgba(0,0,0,0.12);
           border-radius: 15px;
           padding: 20px;
           opacity: 0;
           visibility: hidden;
           transform: translateX(15px);
           transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
           z-index: 100;
           border: 1px solid rgba(0,0,0,0.05);
        }
        .flyout-box.left {
           left: auto;
           right: 100%;
           transform: translateX(-15px);
        }
        .mega-item-wrapper:hover .flyout-box {
           opacity: 1;
           visibility: visible;
           transform: translateX(0);
        }
        .flyout-box.left:hover .flyout-box {
           transform: translateX(0);
        }

        .mega-subtopic-link {
           display: block;
           font-size: 0.88rem;
           color: #555;
           font-weight: 600;
           text-decoration: none;
           padding: 6px 0;
           transition: 0.2s;
        }
        .mega-subtopic-link:hover {
           color: var(--primary-color);
           padding-left: 5px;
        }

        .site-header {
           height: 0; 
           position: relative;
           z-index: 2000;
        }
      `,
        }}
      />
    </header>
  );
};

export default Header;
